<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("modifier", 1) }} {{ $tc("category", 1) }}
      </div>
      <router-link class="btn-blue" to="raw-materials-categories"
        >{{ $tc("modifier", 1) }} {{ $tc("category", 1) }}
        {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-4 align-self-center my-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="category_name"
                name="category_name"
                id="category_name"
                v-validate="'required'"
              />
              <label>Category Name</label>
            </div>
          </div>
        </div>

        <div class="fnb-flag align-self-center">
          <div class="d-flex align-items-center">
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox"
              style="padding-bottom: 0px"
              v-model="category_is_active"
              unchecked-value="N"
              value="Y"
            >
            </b-form-checkbox>
            <span style="white-space: nowrap">Active</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="mt-1 mb-2 sectionTitleSm">
            {{ "Raw Materials Mapping" }}
          </div>
        </div>
        <div class="col-8 align-self-center my-3">
          <div class="dropdown-curve-container">
            <label
              :class="mappedArray.length > 0 ? 'shift-up' : ''"
              style="font-weight: 600"
              >{{ "Raw Materials" }}</label
            >
            <multiselect
              :options="rawMaterials"
              :close-on-select="false"
              :clear-on-select="false"
              v-model="mappedArray"
              :searchable="true"
              :multiple="true"
              label="rm_name"
              track-by="rm_id"
              ref="rm_name"
            >
              <template slot="option" slot-scope="props">
                <span v-if="props.option.alt_rm_name">{{
                  props.option.alt_rm_name
                }}</span>
                <span v-if="props.option.alt_rm_name"
                  >- ({{ props.option.rm_name }})</span
                >
                <span v-else>{{ props.option.rm_name }}</span>
              </template>
              <template slot="tag" slot-scope="props">
                <span class="multiselect__tag">
                  <span v-if="props.option.alt_rm_name">{{
                    props.option.alt_rm_name
                  }}</span>
                  <span v-if="props.option.alt_rm_name"
                    >- ({{ props.option.rm_name }})</span
                  >
                  <span v-else>{{ props.option.rm_name }}</span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    @keydown.enter.prevent="
                      removeElement(props.option, 'rm_name')
                    "
                    @mousedown.prevent="removeElement(props.option, 'rm_name')"
                    class="multiselect__tag-icon"
                  ></i>
                </span>
              </template>
            </multiselect>
            <p class="error_message"></p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="raw-materials-categories"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PosFnbService from "@/services/PosFnbService";
  export default {
    data() {
      return {
        submitted: false,
        btenable: false,
        category_name: "",
        category_id: null,
        category_is_active: "Y",
        mappedArray: [],
        rawMaterials: [],
        action: "ADD",
      };
    },
    mounted() {
      const { id } = this.$route.query;
      if (id) {
        this.category_id = id;
        this.getModifierDetails(id);
        this.action = "EDIT";
      }
      this.getRawMaterials();
    },
    methods: {
      removeElement: function (element, ref) {
        this.$refs[ref].removeElement(element);
      },
      onResetForm: function () {
        this.category_id = null;
        this.category_name = "";
        this.category_is_active = "Y";
        this.mappedArray = [];
      },
      getModifierDetails(category_id) {
        let payload = {
          category_id: category_id,
        };
        PosFnbService.GetModifierById(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records && data.Records.length) {
              this.category_name = data.Records[0]["category_name"];
              this.category_is_active = data.Records[0]["category_is_active"];
              this.category_id = data.Records[0]["category_id"] || null;
              this.mappedArray = data.Records[0]["mappedArray"];
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      getRawMaterials: function () {
        let loader = this.$loading.show();
        this.rawMaterials = [];
        let payload = {
          limit: 10000,
          currentPage: 1,
          searchKey: "rm_name",
          searchValue: "",
          columnName: "rm_name",
          orderBy: "asc",
          filter_is_active: "Y",
        };
        PosFnbService.GetRawMaterialsList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.rawMaterials = data.Records;
            } else {
              this.rawMaterials = [];
              this.$toasted.show("No Records Found");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      },
      onFinalSubmit(flag) {
        if (!this.category_name) {
          return this.$toasted.show("Please Enter Category Name");
        } else {
          let payload = {
            category_name: this.category_name,
            category_id: this.category_id,
            category_is_active: this.category_is_active,
            action: this.category_id ? "EDIT" : "ADD",
            mappingArray: this.mappedArray,
          };
          let loader = this.$loading.show();
          this.submitted = true;
          PosFnbService.AddEditModifierCategory(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                this.$toasted.show(data.message || "Added Successfully");
                if (flag) {
                  this.$router.push({
                    path: "modifier-categories",
                  });
                }
              } else {
                this.$toasted.show(data.message || "Something Went Wrong!");
              }
            })
            .finally(() => {
              loader.hide();
              this.submitted = false;
            });
        }
      },
    },
  };
</script>

<style>
  .sectionTitleSm {
    font-size: 21px;
    font-weight: bold;
    color: var(--blue);
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/Modifiers/AddModifier.vue